export const NEWSLETTER_UNSUBSCRIBE_LINK_VARIABLE = 'unsubscribeLink';
export const NEWSLETTER_UNSUBSCRIBE_WIDGET_VARIABLE = 'unsubscribeWidget';

const defaultLinkStyles = [
  'color:#6b7280',
  'text-decoration:underline'
].join(';');

const defaultContainerStyles = [
  'margin-top:24px',
  'padding-top:16px',
  'border-top:1px solid #e5e7eb',
  'font-size:12px',
  'line-height:1.5',
  'color:#6b7280',
  'text-align:center'
].join(';');

export const getPublicBaseUrl = (): string => {
  return (String(process.env.REACT_APP_PUBLIC_BASE_URL || '').trim() || window.location.origin).replace(/\/+$/g, '');
};

export const buildNewsletterUnsubscribeUrl = (email: string): string => {
  const normalized = String(email || '').trim().toLowerCase();
  return `${getPublicBaseUrl()}/newsletter/unsubscribe?email=${encodeURIComponent(normalized)}`;
};

export const buildNewsletterUnsubscribeWidget = (unsubscribeUrl: string): string => {
  return [
    `<div style="${defaultContainerStyles}">`,
    '  <p style="margin:0 0 6px 0;">You are receiving this newsletter because you are a customer contact.</p>',
    `  <p style="margin:0;"><a href="${unsubscribeUrl}" style="${defaultLinkStyles}">Unsubscribe from future newsletters</a></p>`,
    '</div>'
  ].join('');
};
